(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p5-board-size-chart"] && !Shopify.designMode) return;
  try {
    (function(){
  function norm(v){return String(v||'').toUpperCase().replace(/^2027\s+PHASE\s+FIVE\s+/,'').replace(/[^A-Z0-9]+/g,' ').trim().replace(/\s+/g,' ')}
  function init(root){
    if(root.dataset.p5Ready==='1')return;
    var ref=root.querySelector('[data-p5-size-reference]');
    var body=root.querySelector('[data-p5-size-rows]');
    if(!ref||!body)return;
    var data;
    try{data=JSON.parse(ref.textContent)}catch(e){return}
    var model=norm(root.dataset.productTitle);
    var rows=(data.rows||[]).filter(function(r){return !String(r.id||'').includes('-2026-')&&norm(r.family)===model&&r.heightFrom!=null&&r.heightTo!=null&&r.high!=null});
    rows.sort(function(a,b){return Number(a.size)-Number(b.size)});
    if(!rows.length)return;
    body.innerHTML=rows.map(function(r){
      var size=Number(r.size)%1===0?Number(r.size).toFixed(0):String(r.size);
      return '<tr><td>'+size+'&quot;</td><td>'+r.high+' kg</td><td>'+r.heightFrom+' - '+r.heightTo+' cm</td></tr>';
    }).join('');
    root.hidden=false;
    root.dataset.p5Ready='1';
  }
  function run(){document.querySelectorAll('[data-p5-reference-size-chart]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p5-live-region"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.querySelector('[data-p5-region]');
  if (!bar) return;
  let dismissed = false;
  try { dismissed = localStorage.getItem('p5-live-region-choice') === '1'; } catch (_) {}
  bar.hidden = dismissed;
  bar.addEventListener('click', event => {
    if (!event.target.closest('[data-p5-region-choice]')) return;
    try { localStorage.setItem('p5-live-region-choice','1'); } catch (_) {}
    bar.hidden = true;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
